import {all, take} from 'redux-saga/effects'

import {CLOSE_MODAL} from '../../../actions/ui/index.js'
import confirmAttemptToAllocateModal from './confirmAttemptToAllocateModal.js'
import confirmDeallocateModal from './confirmDeallocateModal.js'
import endiciaCreditCardModal from './endiciaCreditCardModal.js'
import exportInsuranceHistoryModal from './exportInsuranceHistoryModal.js'
import editInstructionsModal from './editInstructionsModal.js'

export function* waitForModalConfirm() {
  const action = yield take(CLOSE_MODAL)

  return action.payload.meta.isConfirmed
}

export default function* modalSaga() {
  yield all([
    confirmAttemptToAllocateModal(),
    confirmDeallocateModal(),
    endiciaCreditCardModal(),
    exportInsuranceHistoryModal(),
    editInstructionsModal(),
  ])
}
